import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type SchedulerState = CommonTableState;

const initialState: SchedulerState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "name", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        density: "compact",
        columnVisibility: {
            description: false,
            creator: false,
            created: false,
            cronExpression: false,
            repeatTime: false,
        },
        columnOrder: [
            "name",
            "description",
            "status",
            "creator",
            "jobClass",
            "fireTime",
            "nextFireTime",
            "cronExpression",
            "repeatTime",
            "created",
            "mrt-row-actions",
        ],
    },
};

export const schedulerSlice = createSlice({
    name: "scheduler",
    initialState: initialState,
    reducers: {
        updateSchedulerTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updateSchedulerTableState} = schedulerSlice.actions;

export default schedulerSlice.reducer;
